<template>
  <div id="component">
    <!-- Slider main container -->
    <!-- Slider main container -->
    <div class="swiper-container">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div id="hudOne" class="swiper-slide">
          <p class="swiperTitle">Cycling Route Statistics</p>
          <div class="hudOneGrid">
            <D3PieChart
              @pieSaysUpdateHUD="hudWillUpdate"
              :markerList="markerList"
              :localMapIsStatic="localMapIsStatic"
              :refreshStats="refreshStats"
            ></D3PieChart>
            <div id="placeholder">
              <div>
                <h6>{{ co2Value }} lbs</h6>
                <p>CO2 Offset</p>
              </div>
              <div>
                <h6>{{ distance }} mi</h6>
                <p>Distance</p>
              </div>
              <div>
                <h6>{{ minutes }} min</h6>
                <p>Ride Time</p>
              </div>
            </div>
            <!-- <div class="legend">
              <div style="color:#a05121">
                High-Traffic Roadways
              </div>
              <div style="color:#5a7ebc">
                Residential Street
              </div>
              <div style="color:#5e8b79">
                Dedicated Bike-Path
              </div>
              <div style="color:#8d8d8d">
                Miscellaneous Streets
              </div>
            </div> -->
            <div id="HUDSwitchControl">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="HUDSwitch"
                  checked
                  @click="toggleSafeRouting"
                />
                <label class="custom-control-label" for="HUDSwitch"></label>
              </div>
              <p>Safe Routing</p>
            </div>
          </div>
        </div>
        <div id="hudTwo" class="swiper-slide">
          <p class="swiperTitle">Local Businesses & Events</p>
          <YelpControls v-on="$listeners" />
        </div>
        <div id="hudThree" class="swiper-slide">
          <p class="swiperTitle">
            Additional Statistics, Analysis, Services<br />(conditional on project funding)
            <br>
            <span style="color:#70c2c2; font-size:.75em"
              >Calendar of Tucson Events | Regular Coffee Outside Group Rides | Discounts with Local Shops | Expansion to Other Sectors (Water, Food, Energy, Housing) </span>
          </p>
          <br />
        </div>
        <!-- <div id="hudFour" class="swiper-slide">
          <p class="swiperTitle">Elevation Statistics</p>
        </div>
        <div id="hudFive" class="swiper-slide">
          <p class="swiperTitle">Environmental Statistics</p>
        </div> -->
      </div>
      <!-- If we need pagination -->
      <!-- <div class="swiper-pagination"></div> -->

      <!-- If we need navigation buttons -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>

      <!-- If we need scrollbar -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>

    <div id="hudTwo"></div>
    <div id="hudThree"></div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination } from "swiper"; // import Swiper JS core version + navigation, pagination modules:
import "swiper/swiper-bundle.css"; // import Swiper styles
Swiper.use([Navigation, Pagination]); // configure Swiper to use modules
// import Statistics from "@/components/Statistics.vue";
import YelpControls from "@/components/YelpControls.vue";
import D3PieChart from "@/components/D3PieChart.vue";
import { mapState } from "vuex";

export default {
  props: {
    refreshStats: {
      type: Boolean
    },
    markerList: {
      type: Array
    },
    localMapIsStatic: {
      type: Boolean
    }
  },
  data() {
    return {
      co2Value: null,
      distance: null,
      minutes: null
    };
  },
  components: {
    YelpControls,
    D3PieChart
  },
  mounted() {
    this.initSlider();
  },
  computed: {
    ...mapState(["uiRouteType"])
  },
  methods: {
    hudWillUpdate(array) {
      this.co2Value = Math.round(array[0] * 10) / 10;
      this.distance = Math.round(array[1] * 10) / 10;
      this.minutes = Math.round(this.distance * 6); //12mph = 1 mile in 5 min OR 10mph = 1 mile in 6 min
    },
    toggleSafeRouting: function() {
      this.$store.commit("toggleSafeRouting");
      this.$emit("toggleSafeRouting");
      this.$emit("toggleRefreshStats");
    },
    initSlider() {
      //var mySwiper =
      new Swiper(".swiper-container", {
        // Optional parameters
        direction: "horizontal",
        loop: false,

        // If we need pagination
        // pagination: {
        //   el: ".swiper-pagination"
        // },

        // Navigation arrows
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }

        // And if we need scrollbar
        // scrollbar: {
        //   el: ".swiper-scrollbar",
        //   draggable: true,
        //   hide: false
        // }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#component {
  .swiper-button-next,
  .swiper-button-prev {
    color: white;
    transform: scale(0.6);
  }

  .swiper-button-next {
    right: 5px;
  }

  .swiper-button-prev {
    left: 5px;
  }

  .swiper-container {
    .swiper-wrapper {
      .swiperTitle {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 25px;
        background-color: #363636;
        color: white;
        font-size: 0.75em;
        font-style: italic;
      }
    }

    width: 100%;
    height: 100%;

    .custom-control-label::before {
      border-color: brown;
      background-color: brown;
      border: none;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
      border-color: rgb(3, 94, 18);
      background-color: rgb(3, 94, 18);
    }
  }

  .swiper-slide {
    background-color: #363636;
    text-align: center;
    font-size: 18px;
    z-index: 2;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  position: absolute;
  width: 100vw;
  height: 12vh;
  bottom: 0;

  #hudOne {
    .hudOneGrid {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0px;
      margin: auto;
      width: 90%;
      height: 90%;
      display: grid;
      grid-template-columns: 25% 50% 25%;
      grid-template-rows: 1fr;
      justify-content: center;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        // border: solid 2px yellow;
        height: 8vh;
      }

      #placeholder {
        padding-top: 5px;
        font-size: 10px;
        font-weight: bold;
        color: white;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr;
        align-items: center;
        justify-content: center;

        // display: inline;
        // border: solid 1px grey;

        p,
        h6 {
          margin-bottom: 1px;
        }
      }

      .legend {
        width: auto;
        height: 7vh;
        bottom: 1vh;
        left: calc(40px + 8vh + 10px);
        z-index: 1;
        background-color: #363636;
        // border: solid 1px grey;
        font-size: 12px;
        line-height: 13px;
        font-weight: 900;
        // -webkit-text-stroke-width: .1px;
        // -webkit-text-stroke-color: white;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 1fr 1fr;
        align-items: center;
        text-align: start;
        margin-bottom: 2px;
      }
    }

    #HUDSwitchControl {
      color: white;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      justify-self: center;
      align-self: self-end;

      > .custom-control.custom-switch {
        padding-left: 2.7rem;
      }

      > p {
        font-size: 0.6em;
      }
    }

    // background-color: grey;
    // display: grid;
    // grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    // grid-template-rows: 1fr;
    // grid-gap: 2px;
  }

  #hudTwo {
  }

  #hudThree {
  }
}
</style>
